// async function __CartChanged(event) {

//     const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
//     setTimeout(()=>{      
//       const atr = document.querySelector(".hidden_atr_div");
//       var freeGiftId = parseInt(atr?.getAttribute('free_gift'));
//       var freeGiftThreshold = atr?.getAttribute('freeGiftThreshold');
//       var freeGiftValue = atr?.getAttribute('free_gift_value');
//       var threshold_value = atr?.getAttribute('threshold_value');
//       var cartTotal = cartContent.total_price ;
//       var cart = cartContent;
//       var giftInCart = false;
//       if(freeGiftValue == 'true'){
//         freeGiftValue = true;
//       }else{
//         freeGiftValue = false;
//       }
//       if(threshold_value == 'enabled'){
//         threshold_value = true;
//       }else{
//         threshold_value = false;
//       }
//       // console.log(threshold_value);
//       // console.log(freeGiftValue);
  
//       Array.from(cart.items).find(item=>{
//         if(item.id == freeGiftId){
//           giftInCart = true;          
//         }
//       });

//       const _currentURL = new URL(window.location.href);
//       const _params = new URLSearchParams(_currentURL.searchParams);
//       const _stringParam = _params.toString();
//       const _has_klaviyoKey = _stringParam.includes('klaviyo_free_gift');

//       if(_has_klaviyoKey) sessionStorage.setItem("has_free_gift", "true");

//       const alreadyHaveFreeGift = Array.from(cart.items).some(item => item.id === freeGiftId && item.properties.hasOwnProperty('_abandoned_gift_product'));

//       // console.log("test: ", Array.from(cart.items).some(item => item.line_level_total_discount === 0 && item.properties.hasOwnProperty('_welcome_series_klaviyo')));
                  
//       var welcomeSeriesKlaviyoFreeGift = false;
                  
//       if(sessionStorage.getItem("has_free_gift") == 'true'){
//        welcomeSeriesKlaviyoFreeGift = Array.from(cart.items).some(item => Array.from(cart.items).some(item => item.properties.hasOwnProperty('_welcome_series_klaviyo'))); 
//       }
//       console.log(welcomeSeriesKlaviyoFreeGift);

//       if(alreadyHaveFreeGift && cart.items.length > 1) return;
      
//       // Check if the cart total price exceeds the threshold for free gift
      
//       if (threshold_value && cartTotal >= freeGiftThreshold || welcomeSeriesKlaviyoFreeGift) {
//         // Check if the free gift is not already in the cart
//         if (!giftInCart) {
//           var freeGift = {
//             items: [
//               {
//                 id: freeGiftId,
//                 quantity: 1
//               }
//             ]
//           };
  
//           // Make an AJAX request to add the free gift to the cart
//           fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(freeGift)
//           })
//           .then(response => response.json())
//           .then(data => {
//             // console.log('Free gift added:', data);
//             if(window.themeVariables.settings.pageType == 'cart'){
//               window.location.href = `${Shopify.routes.root}cart`;
//             } else{
//               _onCartRefresh();
//             }
//             // location.reload(); // Reload the page to reflect changes in the cart
//           })
//           .catch(error => {
//             console.error('Error adding free gift:', error);
//           });
//         }
//       } else if(freeGiftValue == true && threshold_value == false || welcomeSeriesKlaviyoFreeGift){
//         if (!giftInCart) {
//           var freeGift = {
//             items: [
//               {
//                 id: freeGiftId,
//                 quantity: 1
//               }
//             ]
//           };
  
//           // Make an AJAX request to add the free gift to the cart
//           fetch('/cart/add.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify(freeGift)
//           })
//           .then(response => response.json())
//           .then(data => {
//             // console.log('Free gift added:', data);
//             if(window.themeVariables.settings.pageType == 'cart'){
//               window.location.href = `${Shopify.routes.root}cart`;
//             } else{
//               _onCartRefresh();
//             }
//             // location.reload(); // Reload the page to reflect changes in the cart
//           })
//           .catch(error => {
//             console.error('Error adding free gift:', error);
//           });
//         } else{
//           //   if(giftInCart){
//           //   // console.log(giftInCart);
            
//           //   let updates = {
//           //     [freeGiftId]: 0
//           //   };
            
//           //   fetch(window.Shopify.routes.root + 'cart/update.js', {
//           //     method: 'POST',
//           //     headers: {
//           //       'Content-Type': 'application/json'
//           //     },
//           //     body: JSON.stringify({ updates })
//           //   })
//           //   .then(response => response.json())
//           //   .then(data => {
//           //     // console.log('Free gift removed:', data);
//           //     this._onCartRefresh();
//           //     // location.reload();
//           //   })
//           //   .catch((error) => {
//           //     console.error('Error:', error);
//           //   });
//           // }
//         }
//       }else{
//         if(giftInCart){
//           // console.log(giftInCart);
          
//           let updates = {
//             [freeGiftId]: 0
//           };
          
//           fetch(window.Shopify.routes.root + 'cart/update.js', {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json'
//             },
//             body: JSON.stringify({ updates })
//           })
//           .then(response => response.json())
//           .then(data => {
//             // console.log('Free gift removed:', data);
//             if(window.themeVariables.settings.pageType == 'cart'){
//               window.location.href = `${Shopify.routes.root}cart`;
//             } else{
//               _onCartRefresh();
//             }
//             // location.reload();
//           })
//           .catch((error) => {
//             console.error('Error:', error);
//           });
//         }
//       }
//     }, 500);
//     // __CartChanged();
//     // const updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"][extractSectionId(this)], "text/html");
//     // if (event.detail.cart["item_count"] > 0) {
//     //   const currentLineItemsElement = this.querySelector(".cart-drawer__line-items"), updatedLineItemsElement = updatedDrawerContent.querySelector(".cart-drawer__line-items");
//     //   if (!currentLineItemsElement) {
//     //     this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
//     //     UpdateCartComplementary();
//     //   } else {
//     //     setTimeout(() => {
//     //       currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
//     //       UpdateCartComplementary();
//     //     }, event.detail.baseEvent === "variant:add" ? 0 : 1250);
//     //     this.querySelector('[slot="footer"]').replaceChildren(...updatedDrawerContent.querySelector('[slot="footer"]').childNodes);
//     //   }
//     // } else {
//     //   await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
//     //   this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
//     //   animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
//     //   UpdateCartComplementary();
//     // }
//     // updateTotalPrice();
//   }

// __CartChanged();

// window.solarflowerGiftSet = async function(){
//   const CartDrawer = document.querySelector('cart-drawer');
//   const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
//   setTimeout(()=>{    
//     const solarflower_gift_set_data_all = document.querySelectorAll('.solarflower_gift_set_data, .additional_products_gift_set_data_1, .additional_products_gift_set_data_2, .additional_products_gift_set_data_3, .ecoflow_stream_ultra_gift_set_data');
//     if(solarflower_gift_set_data_all.length > 0){
//       solarflower_gift_set_data_all.forEach(solarflower_gift_set_data => {
//         if(solarflower_gift_set_data){
//           const converted_html = new DOMParser().parseFromString(solarflower_gift_set_data.innerText, "text/html");
//           const solarFlowerInput = converted_html?.querySelector('.solarflower_data_input');
//           if(!solarFlowerInput) return;
//           var solarGiftInCart = false;
//           var solarFlowerGiftId = solarFlowerInput.getAttribute('data-solar-gift-id');
//           var has_flower_product_in_cart = solarFlowerInput.getAttribute('data-has-solarflower-in-cart') == 'true';
//           Array.from(cartContent.items).find(item=>{
//             if(item.id == solarFlowerGiftId){
//               solarGiftInCart = true;          
//             }
//           });
//           console.log("has_flower_product_in_cart: ", has_flower_product_in_cart, "solarGiftInCart: ", solarGiftInCart);
//           if(has_flower_product_in_cart && solarGiftInCart) return;
//           if(has_flower_product_in_cart && !solarGiftInCart){
//             var SolarFreeGift = {
//               items: [
//                 {
//                   id: solarFlowerGiftId,
//                   quantity: 1
//                 }
//               ]
//             };
//             fetch('/cart/add.js', {
//               method: 'POST',
//               headers: {
//                 'Content-Type': 'application/json'
//               },
//               body: JSON.stringify(SolarFreeGift)
//             })
//             .then(response => response.json())
//             .then(data => {
//               console.log('Solar Flower Free gift added:', data);
//               if(window.themeVariables.settings.pageType == 'cart'){
//                 window.location.href = `${Shopify.routes.root}cart`;
//               } else{
//                 CartDrawer._onCartRefresh();
//               }
//             })
//             .catch(error => {
//               console.error('Error adding free gift:', error);
//             });
//           }else{
//             if(!has_flower_product_in_cart && solarGiftInCart){
//               let updates = {
//                 [solarFlowerGiftId]: 0
//               };
              
//               fetch(window.Shopify.routes.root + 'cart/update.js', {
//                 method: 'POST',
//                 headers: {
//                   'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ updates })
//               })
//               .then(response => response.json())
//               .then(data => {
//                 console.log('Solar Flower Free gift Removed');
//                 if(window.themeVariables.settings.pageType == 'cart'){
//                   window.location.href = `${Shopify.routes.root}cart`;
//                 } else{
//                   CartDrawer._onCartRefresh();
//                 }
//               })
//               .catch((error) => {
//                 console.error('Error:', error);
//               });
//             }
//           }
//         }
//       })
//     }
//   }, 550);
// }
// window.solarflowerGiftSet();


async function __CartChanged(event) {

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    setTimeout(()=>{      
      const atr = document.querySelector(".hidden_atr_div");
      var freeGiftId = parseInt(atr?.getAttribute('free_gift'));
      var freeGiftThreshold = atr?.getAttribute('freeGiftThreshold');
      var freeGiftValue = atr?.getAttribute('free_gift_value');
      var threshold_value = atr?.getAttribute('threshold_value');
      var cartTotal = cartContent.total_price ;
      var cart = cartContent;
      var giftInCart = false;
      if(freeGiftValue == 'true'){
        freeGiftValue = true;
      }else{
        freeGiftValue = false;
      }
      if(threshold_value == 'enabled'){
        threshold_value = true;
      }else{
        threshold_value = false;
      }
      // console.log(threshold_value);
      // console.log(freeGiftValue);
  
      var free_gift_parent_ids = atr?.getAttribute('free_gift_parent_ids') || "";
      var parentIdsArray = free_gift_parent_ids.split(',').filter(id => id);
      var requiredQuantity = 0;
      parentIdsArray.forEach(id => {
        let matchingItem = cartContent.items.find(item => item.product_id == id);
        if (matchingItem) {
           requiredQuantity += matchingItem.quantity;
        }
      });
      requiredQuantity = requiredQuantity > 0 ? requiredQuantity : 1;
      
      var giftItemQuantity = 0;
      Array.from(cart.items).find(item=>{
        if(item.id == freeGiftId){
          giftInCart = true;          
          giftItemQuantity = item.quantity;
        }
      });

      const _currentURL = new URL(window.location.href);
      const _params = new URLSearchParams(_currentURL.searchParams);
      const _stringParam = _params.toString();
      const _has_klaviyoKey = _stringParam.includes('klaviyo_free_gift');

      if(_has_klaviyoKey) sessionStorage.setItem("has_free_gift", "true");

      const alreadyHaveFreeGift = Array.from(cart.items).some(item => item.id === freeGiftId && item.properties.hasOwnProperty('_abandoned_gift_product'));

      // console.log("test: ", Array.from(cart.items).some(item => item.line_level_total_discount === 0 && item.properties.hasOwnProperty('_welcome_series_klaviyo')));
                  
      var welcomeSeriesKlaviyoFreeGift = false;
                  
      if(sessionStorage.getItem("has_free_gift") == 'true'){
       welcomeSeriesKlaviyoFreeGift = Array.from(cart.items).some(item => Array.from(cart.items).some(item => item.properties.hasOwnProperty('_welcome_series_klaviyo'))); 
      }
      console.log(welcomeSeriesKlaviyoFreeGift);

      if(alreadyHaveFreeGift && cart.items.length > 1) return;
      
      // Check if the cart total price exceeds the threshold for free gift
      
      if (threshold_value && cartTotal >= freeGiftThreshold || welcomeSeriesKlaviyoFreeGift) {
        // Check if the free gift is not already in the cart or quantity needs update
        if (!giftInCart || giftItemQuantity !== requiredQuantity) {
          if (!giftInCart) {
            var freeGift = {
              items: [
                {
                  id: freeGiftId,
                  quantity: requiredQuantity
                }
              ]
            };
    
            // Make an AJAX request to add the free gift to the cart
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(freeGift)
            })
            .then(response => response.json())
            .then(data => {
              if(window.themeVariables.settings.pageType == 'cart'){
                window.location.href = `${Shopify.routes.root}cart`;
              } else{
                _onCartRefresh();
              }
            })
            .catch(error => { console.error('Error adding free gift:', error); });
          } else {
            let updates = { [freeGiftId]: requiredQuantity };
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then(data => {
              if(window.themeVariables.settings.pageType == 'cart'){
                window.location.href = `${Shopify.routes.root}cart`;
              } else{
                _onCartRefresh();
              }
            })
            .catch(error => console.error('Error:', error));
          }
        }
      } else if(freeGiftValue == true && threshold_value == false || welcomeSeriesKlaviyoFreeGift){
        if (!giftInCart || giftItemQuantity !== requiredQuantity) {
          if (!giftInCart) {
            var freeGift = {
              items: [
                {
                  id: freeGiftId,
                  quantity: requiredQuantity
                }
              ]
            };
    
            // Make an AJAX request to add the free gift to the cart
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(freeGift)
            })
            .then(response => response.json())
            .then(data => {
              if(window.themeVariables.settings.pageType == 'cart'){
                window.location.href = `${Shopify.routes.root}cart`;
              } else{
                _onCartRefresh();
              }
            })
            .catch(error => { console.error('Error adding free gift:', error); });
          } else {
            let updates = { [freeGiftId]: requiredQuantity };
            fetch(window.Shopify.routes.root + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates })
            })
            .then(response => response.json())
            .then(data => {
              if(window.themeVariables.settings.pageType == 'cart'){
                window.location.href = `${Shopify.routes.root}cart`;
              } else{
                _onCartRefresh();
              }
            })
            .catch(error => console.error('Error:', error));
          }
        }
      }else{
        if(giftInCart){
          // console.log(giftInCart);
          
          let updates = {
            [freeGiftId]: 0
          };
          
          fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(data => {
            // console.log('Free gift removed:', data);
            if(window.themeVariables.settings.pageType == 'cart'){
              window.location.href = `${Shopify.routes.root}cart`;
            } else{
              _onCartRefresh();
            }
            // location.reload();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
        }
      }
    }, 500);
    // __CartChanged();
    // const updatedDrawerContent = new DOMParser().parseFromString(event.detail.cart["sections"][extractSectionId(this)], "text/html");
    // if (event.detail.cart["item_count"] > 0) {
    //   const currentLineItemsElement = this.querySelector(".cart-drawer__line-items"), updatedLineItemsElement = updatedDrawerContent.querySelector(".cart-drawer__line-items");
    //   if (!currentLineItemsElement) {
    //     this.replaceChildren(document.createRange().createContextualFragment(updatedDrawerContent.querySelector(".cart-drawer").innerHTML));
    //     UpdateCartComplementary();
    //   } else {
    //     setTimeout(() => {
    //       currentLineItemsElement.innerHTML = updatedLineItemsElement.innerHTML;
    //       UpdateCartComplementary();
    //     }, event.detail.baseEvent === "variant:add" ? 0 : 1250);
    //     this.querySelector('[slot="footer"]').replaceChildren(...updatedDrawerContent.querySelector('[slot="footer"]').childNodes);
    //   }
    // } else {
    //   await animate4(this.children, { opacity: 0 }, { duration: 0.15 }).finished;
    //   this.replaceChildren(...updatedDrawerContent.querySelector(".cart-drawer").childNodes);
    //   animate4(this.querySelector(".empty-state"), { opacity: [0, 1], transform: ["translateY(20px)", "translateY(0)"] }, { duration: 0.15 });
    //   UpdateCartComplementary();
    // }
    // updateTotalPrice();
  }

__CartChanged();

window.solarflowerGiftSet = async function(cart){
  const CartDrawer = document.querySelector('cart-drawer');
  // Callers that already hold a fresh cart pass it in, which avoids a redundant /cart.js round trip
  const cartContent = cart || window.themeCartSnapshot || await (await fetch(`${Shopify.routes.root}cart.js`)).json();
  setTimeout(()=>{
    const solarflower_gift_set_data_all = document.querySelectorAll('.solarflower_gift_set_data, .additional_products_gift_set_data_1, .additional_products_gift_set_data_2, .additional_products_gift_set_data_3, .ecoflow_stream_ultra_gift_set_data, .zendure_mix_pro_gift_set_data');
    if(solarflower_gift_set_data_all.length > 0){
      solarflower_gift_set_data_all.forEach(solarflower_gift_set_data => {
        if(solarflower_gift_set_data){
          const converted_html = new DOMParser().parseFromString(solarflower_gift_set_data.innerText, "text/html");
          const solarFlowerInput = converted_html?.querySelector('.solarflower_data_input');
          if(!solarFlowerInput) return;
          var solarGiftInCart = false;
          var gift_item_quantity = 0;
          var solarFlowerGiftId = solarFlowerInput.getAttribute('data-solar-gift-id');
          var has_flower_product_in_cart = solarFlowerInput.getAttribute('data-has-solarflower-in-cart') == 'true';
          
          var parent_ids = solarFlowerInput.getAttribute('data-parent-ids') || "";
          var parentIdsArray = parent_ids.split(',').filter(id => id);
          var requiredQuantity = 0;
          parentIdsArray.forEach(id => {
            let matchingItem = cartContent.items.find(item => item.product_id == id);
            if (matchingItem) {
               requiredQuantity += matchingItem.quantity;
            }
          });
          requiredQuantity = requiredQuantity > 0 ? requiredQuantity : 1;

          Array.from(cartContent.items).find(item=>{
            if(item.id == solarFlowerGiftId){
              solarGiftInCart = true;          
              gift_item_quantity = item.quantity;
            }
          });
          console.log("has_flower_product_in_cart: ", has_flower_product_in_cart, "solarGiftInCart: ", solarGiftInCart);
          if(has_flower_product_in_cart && solarGiftInCart && gift_item_quantity === requiredQuantity) return;
          
          if(has_flower_product_in_cart && (!solarGiftInCart || gift_item_quantity !== requiredQuantity)){
            if (!solarGiftInCart) {
              var SolarFreeGift = {
                items: [
                  {
                    id: solarFlowerGiftId,
                    quantity: requiredQuantity
                  }
                ]
              };
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(SolarFreeGift)
              })
              .then(response => response.json())
              .then(data => {
                console.log('Solar Flower Free gift added:', data);
                if(window.themeVariables.settings.pageType == 'cart'){
                  window.location.href = `${Shopify.routes.root}cart`;
                } else{
                  CartDrawer._onCartRefresh();
                }
              })
              .catch(error => {
                console.error('Error adding free gift:', error);
              });
            } else {
              let updates = { [solarFlowerGiftId]: requiredQuantity };
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
              })
              .then(response => response.json())
              .then(data => {
                console.log('Solar Flower Free gift Updated');
                if(window.themeVariables.settings.pageType == 'cart'){
                  window.location.href = `${Shopify.routes.root}cart`;
                } else{
                  CartDrawer._onCartRefresh();
                }
              })
              .catch(error => console.error('Error:', error));
            }
          }else{
            if(!has_flower_product_in_cart && solarGiftInCart){
              let updates = {
                [solarFlowerGiftId]: 0
              };
              
              fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              })
              .then(response => response.json())
              .then(data => {
                console.log('Solar Flower Free gift Removed');
                if(window.themeVariables.settings.pageType == 'cart'){
                  window.location.href = `${Shopify.routes.root}cart`;
                } else{
                  CartDrawer._onCartRefresh();
                }
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }
          }
        }
      })
    }
  }, 0);
}

window.solarflowerGiftSet();



(function () {
  const mountingOptionsInputs = document.querySelectorAll(
    ".input-mounting__options"
  );
  if (mountingOptionsInputs.length) {
    mountingOptionsInputs.forEach((input) =>
      input.addEventListener(
        "change",
        handleMountingInputChange.bind(this),
        true
      )
    );
  }

  function handleMountingInputChange(event) {
    const target = event.currentTarget;
    const value = target.value;
    const optionPosition = target.getAttribute("data-option-position");
    const optionWrapper = document.querySelector(
      `.variant-picker__option[data-option-index='${optionPosition}']`
    );
    const optionButton = optionWrapper.querySelector(
      `[data-option-selector] button[value='${value}']`
    );
    if (optionButton) {
      optionButton.click();
    }
    console.log(optionButton);
    if (document.querySelectorAll(".form-control").length > 0) {
      document.querySelectorAll(".form-control").forEach((form) => {
        const formInput = form.querySelector("input:checked");
        if (formInput) {
          form.click();
        }
      });
    }
  }
})();

const featuredCollectionlist = document.querySelectorAll(
  ".__featured_collection_scrolling"
);
for (var i = 0; i < featuredCollectionlist.length; i++) {
  featuredCollectionlist[i].setAttribute("id", "featured_collection_" + i);
}

var scrollLinks = document.querySelectorAll(".collection__nav__item a");
function smoothScrollAndRedirect(e) {
  e.preventDefault();

  var targetUrl = this.getAttribute("href");
  var targetId = targetUrl.substring(targetUrl.indexOf("#"));
  var targetElement = document.querySelector(targetId);
  window.location.href = targetUrl;
  if (targetElement) {
    setTimeout(function () {
      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }
}
scrollLinks.forEach(function (link) {
  link.addEventListener("click", smoothScrollAndRedirect);
});



setTimeout(() => {
  const klarna_popup = document.querySelector("#klarna_popup");
  if (klarna_popup) {
    klarna_popup.addEventListener("click", () => {
      const InnerPopup = document.querySelector(".product_popup");
      document.body.classList.add("klarna-overflow");
      InnerPopup.classList.add("show");
      InnerPopup.style.display = "";
      InnerPopup.querySelector(".closepopup").addEventListener("click", () => {
        document.body.classList.remove("klarna-overflow");
        InnerPopup.style.display = "none";
        InnerPopup.classList.remove("show");
      });
      InnerPopup.querySelector(".button").addEventListener("click", (e) => {
        e.preventDefault();
        document.body.classList.remove("klarna-overflow");
        InnerPopup.style.display = "none";
        InnerPopup.classList.remove("show");
      });
    });
  }
}, 500);

// Proxy clicks on the static Alma badge to the hidden Alma widget button.
document.addEventListener("click", (event) => {
  const trigger = event.target.closest("[data-alma-payment-trigger]");
  if (!trigger) return;

  const slot = trigger.closest("[data-alma-payment-slot]");
  if (!slot || slot.classList.contains("is-hidden")) return;

  const almaButton =
    slot.querySelector('#alma-widget-payment-plans-main-container button[type="button"]') ||
    slot.querySelector(".alma-widget-host button") ||
    slot.querySelector('[data-testid="Alma-Logo"]')?.closest("button");

  if (almaButton && almaButton !== trigger) {
    event.preventDefault();
    almaButton.click();
  }
});




document.addEventListener("DOMContentLoaded", function () {
  function handleAccordionClick() {
    var description = this.nextElementSibling;
    if (description.style.height === "0px" || description.style.height === "") {
      description.style.height = description.scrollHeight + "px";
      this.classList.add("activeButton");
    } else {
      description.style.height = "0px";
      this.classList.remove("activeButton");
    }
  }

  function handleResize() {
    if (window.innerWidth <= 749) {
      var headings = document.querySelectorAll(
        ".seo-section .accordion_heading"
      );
      headings.forEach(function (heading) {
        heading.removeEventListener("click", handleAccordionClick);
        heading.addEventListener("click", handleAccordionClick);
      });
    } else {
      var headings = document.querySelectorAll(
        ".seo-section .accordion_heading"
      );
      headings.forEach(function (heading) {
        heading.removeEventListener("click", handleAccordionClick);
      });
    }
  }

  handleResize();
  window.addEventListener("resize", handleResize);
});

(function () {
  "use strict";

  function trackScroll() {
    var scrolled = window.pageYOffset;
    var coords = document.documentElement.clientHeight;

    if (scrolled > coords) {
      goTopBtn.classList.add("back_to_top-show");
    }
    if (scrolled < coords) {
      goTopBtn.classList.remove("back_to_top-show");
    }
  }

  function backToTop() {
    if (window.pageYOffset > 0) {
      window.scrollBy(0, -80);
      setTimeout(backToTop, 0);
    }
  }

  var goTopBtn = document.querySelector(".back_to_top");

  window.addEventListener("scroll", trackScroll);
  goTopBtn.addEventListener("click", backToTop);
})();

const accordionItemHeaders = document.querySelectorAll(
  ".footer .footer__block--menu .footer-menu-heading"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    accordionItemHeaders.forEach((item) => {
      if (item !== accordionItemHeader) {
        item.classList.remove("active");
        item.nextElementSibling.style.maxHeight = 0;
      }
    });

    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});
var heading_title = '';
var heading_title1 = '';
if(document.querySelectorAll(".custom-main-article .article-content-wrap .prose h3").length > 0){
  heading_title = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h3");
}
if(heading_title.length > 0){  
  heading_title.forEach(function (element) {
    let text = element.textContent;
    let transformedText = text
      .toLowerCase()
      .replace(/\./g, "")               
      .replace(/\s+/g, "-")             
      .replace(/^-+/, "")               
      .replace(/-+$/, ""); 
    element.id = transformedText;
    element.setAttribute("data-located", transformedText); 
  });
}
if(document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2").length > 0){
  heading_title1 = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2");
}
if(heading_title1.length > 0){  
  heading_title1.forEach(function (element) {
    let text = element.textContent;
    let transformedText = text
      .toLowerCase()
      .replace(/\./g, "")               
      .replace(/\s+/g, "-")             
      .replace(/^-+/, "")               
      .replace(/-+$/, ""); 
    element.id = transformedText;
    element.setAttribute("data-located", transformedText); 
  });
}
// else{
//   heading_title = document.querySelectorAll(".custom-main-article .article-content-wrap .prose h2");
// }


function setupNavigationScroll() {
  const AllArticleLi = document.querySelectorAll(".article-navigation-left li");
  AllArticleLi.forEach((li) => {
    li.addEventListener("click", () => {
      const LiAttr = li.querySelector("a").getAttribute("data-href");
      const LocatedAttr = document.querySelectorAll("[data-located]");
      console.log(LiAttr);
      console.log(LocatedAttr);
      AllArticleLi.forEach((currentLi) => {
        currentLi.classList.remove("active");
      });
      li.classList.add("active");
      LocatedAttr.forEach((attr) => {
        const located_href = attr.getAttribute("id");
        // console.log("attr: ", located_href);
        // console.log("LiAttr: ", LiAttr);
        if (located_href == LiAttr) {
          var element = document.getElementById(`${located_href}`);
          var offsetTop = element.offsetTop - 100;
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  setupNavigationScroll();
});

setTimeout(function () {
  setupNavigationScroll();
}, 1000);

// jQuery(document).ready(function () {
//   if(jQuery("#slider-for").length > 0){
//     jQuery("#slider-for").slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       dots: false,
//       infinite: true,
//       autoplaySpeed: 2000,
//       pauseOnHover: false,
//     });
//    } 
//   });

if (typeof jQuery !== 'undefined') {
jQuery(function ($) {
  var $slider = $("#slider-for");

  if ($slider.length && typeof $.fn.slick === "function") {
    if (!$slider.hasClass("slick-initialized")) {
      $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
      });
    }
  }
});
}

if (typeof jQuery !== 'undefined') {
  jQuery(document).ready(function () {
   if(jQuery(".collection_list_slider").length){ 
    jQuery(".collection_list_slider").slick({
        slidesToShow: 3,
        autoSlidesToShow: true,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        infinite: false,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2.4,
            slidesToScroll: 1
          }
        }
      ]
     });
    } 
  });
}

// js/common/utilities/format-money.js
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}


// Add upsell product to the cart on new PDP template.
const mainProductContainer = document.querySelectorAll('.product_container_main');
if (mainProductContainer.length > 0) {
  mainProductContainer.forEach(container => {
    const toggleIcon = container.querySelector('.product-image-container');
    if (toggleIcon) {
      toggleIcon.addEventListener('click', () => {
          const productWrapper = container.closest(".product");
          const price_with_product_list = productWrapper?.querySelector('.product-list-with-price')?.classList.toggle('active');
          container.classList.toggle('active');
          const productForm = productWrapper.querySelector(".shopify-product-form");
          // const variantId = container.querySelector('[data-additional-product] [data-variant-id]').getAttribute("data-variant-id");
          if(productWrapper && productForm) {
            productForm.toggleAttribute("data-additional-product");
          }
      });
      toggleIcon.addEventListener('click', AdditionalUpsellProduct.bind(this), true);
    }
  });
}
function AdditionalUpsellProduct(event){
  setTimeout(()=>{    
    var _this = event.target;
    const closestProductInfo = _this?.closest('.product-info');
    const product_container_main = closestProductInfo?.querySelector('.product_container_main');
    const AdditionalProductData = product_container_main?.querySelector('[data-additional-product]')?.querySelector('span');
    const productInfoPrice = closestProductInfo?.querySelector('.product-info__price');
    const comparePrice = productInfoPrice?.querySelector('compare-at-price');
    const regPrice = productInfoPrice?.querySelector('sale-price');
    const productInfoBadge = productInfoPrice?.querySelector('.product-info__badge-list')?.querySelector('on-sale-badge');
    if(product_container_main.classList.contains('active')){    
      comparePrice.innerHTML = `<span class="sr-only">Regulärer Preis</span> ${AdditionalProductData?.getAttribute('data-additional-product-compare-price')}`;
      regPrice.innerHTML = `<span class="sr-only">Angebot</span> ${AdditionalProductData?.getAttribute('data-additional-product-regular-price')}`;
      productInfoBadge.innerHTML = `Sonst ${AdditionalProductData?.getAttribute('data-additional_product-saving-price')} teurer`;
    } else{
      comparePrice.innerHTML = `<span class="sr-only">Regulärer Preis</span> ${AdditionalProductData?.getAttribute('data-main-product-compare-price')}`;
      regPrice.innerHTML = `<span class="sr-only">Angebot</span> ${AdditionalProductData?.getAttribute('data-main-product-regular-price')}`; 
      productInfoBadge.innerHTML = `Sonst ${AdditionalProductData?.getAttribute('data-saving-price')} teurer`
    }
  }, 100);
}
document.addEventListener('variant:change',(evt)=>{
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  const _this = evt.target;
  const prod_info = _this?.closest('.product-info');
  const product_container_main = prod_info?.querySelector('.product_container_main');
  const additional_pro_data = product_container_main?.querySelector('[data-additional-product]')?.querySelector('span');
  if(!additional_pro_data) return;
  const add_pro_c_price = Number(additional_pro_data?.getAttribute('data-only-add-pro-comp-price'));
  const add_pro_price = Number(additional_pro_data.getAttribute('data-only-add-pro-price'));
  const add_final_c_price = add_pro_c_price + evt.detail.variant['compare_at_price'];
  const add_final_price = add_pro_c_price + evt.detail.variant['price'];  
  const saving_price = add_final_c_price - add_final_price;
  additional_pro_data.setAttribute('data-additional-product-compare-price', formatMoney(add_final_c_price, currencyFormat));
  additional_pro_data.setAttribute('data-additional-product-regular-price', formatMoney(add_final_price, currencyFormat));
  additional_pro_data.setAttribute('data-additional_product-saving-price', formatMoney(saving_price, currencyFormat));
  additional_pro_data.setAttribute('data-main-product-compare-price', formatMoney(evt.detail.variant['compare_at_price'], currencyFormat));
  additional_pro_data.setAttribute('data-main-product-regular-price', formatMoney(evt.detail.variant['price'], currencyFormat));
  additional_pro_data.setAttribute('data-saving-price', formatMoney((evt.detail.variant['compare_at_price'] - evt.detail.variant['price']), currencyFormat));
  AdditionalUpsellProduct(evt);
})







document.addEventListener('DOMContentLoaded', function() {
  const readMoreButtons = document.querySelectorAll('.read-more');
  const ArrowIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-md text-token-text-primary"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.7348 21 11.4804 20.8946 11.2929 20.7071L4.29289 13.7071C3.90237 13.3166 3.90237 12.6834 4.29289 12.2929C4.68342 11.9024 5.31658 11.9024 5.70711 12.2929L11 17.5858V4C11 3.44772 11.4477 3 12 3C12.5523 3 13 3.44772 13 4V17.5858L18.2929 12.2929C18.6834 11.9024 19.3166 11.9024 19.7071 12.2929C20.0976 12.6834 20.0976 13.3166 19.7071 13.7071L12.7071 20.7071C12.5196 20.8946 12.2652 21 12 21Z" fill="currentColor"></path></svg>`

  // Count the number of text rows
  function countTextRows(textElement) {
    const computedStyle = window.getComputedStyle(textElement);
    
    const textHeight = textElement.scrollHeight;
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const numberOfRows = Math.round(textHeight / lineHeight);
    
    return numberOfRows;
  }

  function updateButtonVisibility() {
    readMoreButtons.forEach(button => {
      const content = button.closest('.item').querySelector('.content');
      const rows = countTextRows(content);

	  // Set your count of lines
      rows <= 3 ? 
		  button.classList.add('hidden') : 
	      button.classList.remove('hidden');
    });
  }


  readMoreButtons.forEach(button => {
    const content = button.closest('.item').querySelector('.content');

    button.addEventListener('click', function() {
      content.classList.toggle('expanded');
      
      content.classList.contains('expanded') ? 
        button.innerHTML = ArrowIcon : 
        button.innerHTML = ArrowIcon;
    });
  });

  updateButtonVisibility();

  window.addEventListener('resize', function() {
    updateButtonVisibility();
  });
});







if (typeof jQuery !== 'undefined') {
jQuery(document).ready(function () {
  // Check if the screen width is less than or equal to 768px
  if (window.matchMedia("(max-width: 989px)").matches) {
    if(jQuery(".custom_timeline_slider").length){
      jQuery(".custom_timeline_slider").slick({
        slidesToShow: 2, // Show one slide on mobile
        slidesToScroll: 1,
        dots: true, // Add dots for mobile navigation
        arrows: false, // No arrows
        infinite: false, // Disable infinite scrolling
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
            },
          },
        ],
      });
    }  
  }
});
}









// window.setGridHeight = (selector) => {
//   const heightArray = [];
//   const offsetArray = [];
//   const sectionArray = [];
//   const diffrentHeights = [];

//   // Gather offset heights and their indices
//   document.querySelectorAll(selector).forEach((grid, i) => {
//     const offsetTop = grid.closest(`[data-equal]`)?.offsetTop || 0;
//     offsetArray.push({ index: i, offsetheight: offsetTop });
//   });

//   // Identify unique heights
//   offsetArray.forEach((e) => {
//     if (!diffrentHeights.includes(e.offsetheight)) {
//       diffrentHeights.push(e.offsetheight);
//     }
//   });

//   // Adjust each group of elements sharing the same offset height
//   diffrentHeights.forEach((height) => {
//     const data = offsetArray.filter(e => e.offsetheight === height);

//     // Gather heights and find max
//     const getAllHeightArray = data.map((ele) => {
//       const element = document.querySelectorAll(selector)[ele.index];
//       element.style.minHeight = "";  // Reset inline styles first
//       return element.offsetHeight;
//     });

//     const maxHeight = Math.max(...getAllHeightArray);

//     // Apply max height to each element in the group
//     data.forEach((ele) => {
//       document.querySelectorAll(selector)[ele.index].style.minHeight = `${maxHeight}px`;
//     });
//   });
// };

// // Run the function with the selector
// window.setGridHeight('.heading_height');


async function cartCountdownTimer(){  
  var CountDown = document.querySelectorAll('.cart_countdown-timer');

  if (CountDown.length === 0) {
    localStorage.removeItem('countdownEndTime');
    localStorage.removeItem('timerDateValue');
  } else {
    CountDown.forEach(function(count){
      if(count){
        const timerEle = count.querySelector('#countdown_cart');        
        if (!timerEle) {
          localStorage.removeItem('countdownEndTime');
          localStorage.removeItem('timerDateValue');
          return;
        }
        
        function setNewEndTime() {
          const TimerDate = timerEle.getAttribute("data-timer");
          const [minutes, seconds] = TimerDate.split(':').map(Number);
          const totalMilliseconds = (minutes * 60 * 1000) + (seconds * 1000);
          const newEndTime = new Date().getTime() + totalMilliseconds;
          
          localStorage.setItem('countdownEndTime', newEndTime);
          localStorage.setItem('timerDateValue', TimerDate);
          
          return newEndTime;
        }
  
        const currentTimerDate = timerEle.getAttribute("data-timer");
        const storedTimerDate = localStorage.getItem('timerDateValue');
        const storedEndTime = localStorage.getItem('countdownEndTime');
        
        if (!storedEndTime || !storedTimerDate || currentTimerDate !== storedTimerDate) {
          endTime = setNewEndTime();
        } else {
          endTime = parseInt(storedEndTime);
        }
      
        var x = setInterval(function() {
          if (!document.querySelector('.cart_countdown-timer')) {
            clearInterval(x);
            localStorage.removeItem('countdownEndTime');
            localStorage.removeItem('timerDateValue');
            return;
          }
  
          const currentValue = timerEle.getAttribute("data-timer");
          if (currentValue !== localStorage.getItem('timerDateValue')) {
            endTime = setNewEndTime();
          }
  
          var now = new Date().getTime();
          
          var distance = endTime - now;
          
          if (distance < 1000) {
            endTime = setNewEndTime();
            distance = endTime - now;
          }
          
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          // Add leading zeros if needed
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          
          timerEle.innerHTML = "<div>" + minutes + "</div><small>:</small><div>" + seconds + "</div>";
          
        }, 1000);
      }
    });
  }
}
document.addEventListener('DOMContentLoaded', cartCountdownTimer);



window.setGridHeight = (selector) => {
  const heightArray = [];
  const offsetArray = [];
  const sectionArray = [];
  const differentHeights = [];

  // Gather offset heights and their indices
  document.querySelectorAll(selector).forEach((grid, i) => {
    const offsetTop = grid.closest(`[data-equal]`)?.offsetTop || 0;
    offsetArray.push({ index: i, offsetheight: offsetTop });
  });

  // Identify unique heights
  offsetArray.forEach((e) => {
    if (!differentHeights.includes(e.offsetheight)) {
      differentHeights.push(e.offsetheight);
    }
  });

  // Adjust each group of elements sharing the same offset height
  differentHeights.forEach((height) => {
    const data = offsetArray.filter(e => e.offsetheight === height);

    // Gather heights and find max
    const getAllHeightArray = data.map((ele) => {
      const element = document.querySelectorAll(selector)[ele.index];
      element.style.minHeight = "";  // Reset inline styles first
      return element.offsetHeight;
    });

    const maxHeight = Math.max(...getAllHeightArray);

    // Apply max height to each element in the group
    data.forEach((ele) => {
      document.querySelectorAll(selector)[ele.index].style.minHeight = `${maxHeight}px`;
    });
  });
};

// Run the function with the selector only on desktop
if (window.innerWidth >= 990) {
  window.setGridHeight('.heading_height');
}

// Optional: Reapply the function on window resize for dynamic responsiveness
window.addEventListener('resize', () => {
  if (window.innerWidth >= 990) {
    window.setGridHeight('.heading_height');
  } else {
    // Reset heights for smaller viewports
    document.querySelectorAll('.heading_height').forEach((element) => {
      element.style.minHeight = "";
    });
  }
});

// Product single page

// $(document).ready(function() {
//     function updateVariantDisplay() {
//         var urlVariant = new URLSearchParams(window.location.search).get('variant');
//         $('.variant-images').hide();

//         if (urlVariant) {
//             $('.variant-images').each(function() {
//                 var divId = $(this).attr('id');
//                 if (divId === urlVariant) {
//                     $(this).show();
//                 }
//             });
//         } else {
//             $('.variant-images').first().show();
//         }
//     }
//     updateVariantDisplay();
//     $(window).on('popstate', function() {
//         updateVariantDisplay();
//     });
//     setInterval(function() {
//         updateVariantDisplay();
//     }, 1000);
// });

document.addEventListener('DOMContentLoaded', function() {
    function updateVariantDisplay() {
        const urlVariant = new URLSearchParams(window.location.search).get('variant');
        const variantImages = document.querySelectorAll('.variant-images');

        variantImages.forEach(function(image) {
            image.style.display = 'none';
        });

        if (urlVariant) {
            variantImages.forEach(function(image) {
                const divId = image.getAttribute('id');
                if (divId === urlVariant) {
                    image.style.display = 'block';
                }
            });
        } else {
            if (variantImages.length > 0) {
                variantImages[0].style.display = 'block';
            }
        }
    }

    updateVariantDisplay();

    window.addEventListener('popstate', updateVariantDisplay);

    document.addEventListener('variant:change', function(event) {
        if (event.detail?.variant?.id) {
            const variantImages = document.querySelectorAll('.variant-images');
            variantImages.forEach(function(image) {
                image.style.display = 'none';
                if (image.getAttribute('id') === String(event.detail.variant.id)) {
                    image.style.display = 'block';
                }
            });
        } else {
            updateVariantDisplay();
        }
    });
});

document.addEventListener('additional_variant:change',(evt)=>{
  updateAdditionalVariantDisplay(evt.detail.variant.id);
  updateAdditionalVariantScopeOfDelivery(evt.detail.variant.id);
})

function updateAdditionalVariantDisplay(additionalVartiantId){
  const additionalVariantImages = document.querySelectorAll('.addtional_variant_list');
  if(additionalVariantImages.length > 0){
    additionalVariantImages.forEach(function(image) {
      image.style.display = 'none';
    });
    additionalVariantImages.forEach(function(image) {
      if(image.getAttribute('additional_variant_id') === additionalVartiantId){
        image.style.display = 'block';
      }
    });
  }
}

function updateAdditionalVariantScopeOfDelivery(additionalVartiantId){
  const additionalVariantScopeOfDelivery = document.querySelectorAll('.variant-image-item[additional_variant_id]');
  if(additionalVariantScopeOfDelivery.length > 0){
    additionalVariantScopeOfDelivery.forEach(function(scopeOfDelivery) {
      scopeOfDelivery.style.display = 'none';
    });
    additionalVariantScopeOfDelivery.forEach(function(scopeOfDelivery) {
      if(scopeOfDelivery.getAttribute('additional_variant_id') === additionalVartiantId){
        scopeOfDelivery.style.display = '';
      }
    });
  }
}

/* ---------- Product detail text-with-popup ---------- */

// document.addEventListener("DOMContentLoaded", function () {
//   var popupText = document.querySelector(".text-with-popup-text");
//   var popupWrapper = document.querySelector(".text-popup-con-modal-main");
//   var closePopup = document.querySelector(".close-popup");
//   var overlay = document.querySelector(".popup-overlay");
//   var body = document.body;

//   function showPopup() {
//     popupWrapper.style.display = "flex";
//     popupWrapper.style.opacity = "0";
//     setTimeout(() => {
//       popupWrapper.style.opacity = "1";
//       body.classList.add("popup-overflow-hidden");
//     }, 10);
//   }

//   function hidePopup() {
//     popupWrapper.style.opacity = "0";
//     setTimeout(() => {
//       popupWrapper.style.display = "none";
//       body.classList.remove("popup-overflow-hidden");
//     }, 300);
//   }

//   if (popupText) {
//     popupText.addEventListener("click", showPopup);
//   }
//   if (closePopup) {
//     closePopup.addEventListener("click", hidePopup);
//   }
//   if (overlay) {
//     overlay.addEventListener("click", hidePopup);
//   }
// });

window.PopupModal = function (){
  // Event delegation: one document listener serves popups present at load and markup
  // inserted later (deferred sections via assets/deferred-content.js, drawers). Idempotent.
  if (window.__bkPopupModalBound) return;
  window.__bkPopupModalBound = true;
  var body = document.body;

  function showPopup(popupWrapper) {
    if (!popupWrapper) return;
    popupWrapper.style.display = "flex";
    popupWrapper.style.opacity = "0";
    setTimeout(() => {
      if (popupWrapper) {
        popupWrapper.style.opacity = "1";
        body.classList.add("popup-overflow-hidden");
      }
    }, 10);
  }

  function hidePopup(popupWrapper) {
    if (!popupWrapper) return;
    popupWrapper.style.opacity = "0";
    setTimeout(() => {
      if (popupWrapper) {
        popupWrapper.style.display = "none";
        body.classList.remove("popup-overflow-hidden");
      }
    }, 300);
  }

  // Trigger -> its modal: variant-picker keeps its own lookup by data-popup-index.
  function resolvePopup(popupText) {
    const popupMain = popupText.closest('.text-with-popup-main');
    if (!popupMain) return null;

    const popupIndex = popupMain.getAttribute('data-popup-target');
    if (!popupIndex) return null;

    let popupElement = null;
    const variantPicker = popupText.closest('variant-picker');
    if (variantPicker) {
      popupElement = variantPicker.querySelector('[data-popup-index="' + popupIndex + '"]');
    }
    if (!popupElement) {
      popupElement = popupMain.querySelector('.text-popup-con-modal-main');
    }
    return popupElement;
  }

  document.addEventListener('click', function(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const closePopup = target.closest('.close-popup');
    if (closePopup) {
      event.stopPropagation();
      hidePopup(closePopup.closest('.text-popup-con-modal-main'));
      return;
    }

    const overlay = target.closest('.popup-overlay');
    if (overlay) {
      event.stopPropagation();
      hidePopup(overlay.closest('.text-popup-con-modal-main'));
      return;
    }

    const popupText = target.closest('.text-with-popup-text');
    if (popupText) {
      event.stopPropagation();
      showPopup(resolvePopup(popupText));
      return;
    }

    // Click outside: close every open popup that does not contain the click.
    document.querySelectorAll('.text-popup-con-modal-main').forEach(popupWrapper => {
      if (popupWrapper.style.display !== 'flex') return;
      const popupContent = popupWrapper.querySelector('.text-popup-con-modal');
      if (popupContent && popupContent.contains(target)) return;
      hidePopup(popupWrapper);
    });
  });
}

window.PopupModal();

/* ---------- PDF popup buttons (snippets/pdf-popup-button, pdf-popup-button-2) ---------- */

// Binds pdf.js rendering to the PDF popup buttons. Runs for the markup present at
// DOMContentLoaded and again for sections inserted by assets/deferred-content.js
// (event deferred-section:loaded), whose inline <script> tags never execute.
// Opening and closing the modal itself is handled by PopupModal above.
window.BKPdfPopup = (function () {
  function isDesktop() {
    return window.innerWidth > 768;
  }

  function getPdfUrl(popupMain) {
    const pdfElement = isDesktop()
      ? popupMain.querySelector(".getpdf1, .getpdf11")
      : popupMain.querySelector(".getpdf2, .getpdf22");
    return pdfElement ? pdfElement.getAttribute("data-urll") : null;
  }

  function getContainerWidth(pdfContainer) {
    const rectWidth = pdfContainer.getBoundingClientRect().width;
    if (rectWidth > 1) return rectWidth;

    const modal = pdfContainer.closest(".text-popup-con-modal");
    if (modal) {
      const modalRect = modal.getBoundingClientRect().width;
      const modalStyle = window.getComputedStyle(modal);
      const modalPad =
        (parseFloat(modalStyle.paddingLeft) || 0) +
        (parseFloat(modalStyle.paddingRight) || 0);
      if (modalRect > modalPad) return modalRect - modalPad;
    }

    return Math.min(window.innerWidth * 0.95, 1300) - 30;
  }

  function waitForLayout(pdfContainer, callback, attemptsLeft) {
    const width = getContainerWidth(pdfContainer);
    if (width > 1 || attemptsLeft <= 0) {
      callback(width);
      return;
    }
    requestAnimationFrame(function () {
      waitForLayout(pdfContainer, callback, attemptsLeft - 1);
    });
  }

  function computeScale(pdfContainer, containerWidth, pageWidth) {
    if (isDesktop()) {
      return containerWidth / pageWidth;
    }
    const computedStyle = window.getComputedStyle(pdfContainer);
    const paddingLeft = parseFloat(computedStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(computedStyle.paddingRight) || 0;
    const adjustedWidth = containerWidth - paddingLeft - paddingRight - 20;
    return adjustedWidth / pageWidth;
  }

  function renderPdfIfNeeded(popupMain, pdfContainer) {
    if (pdfContainer.getAttribute("data-loaded") === "true") {
      console.warn("PDF already loaded. Skipping duplicate rendering.");
      return;
    }

    const url = getPdfUrl(popupMain);
    if (!url) {
      console.error("No matching PDF URL found.");
      return;
    }

    waitForLayout(pdfContainer, function (containerWidth) {
      if (pdfContainer.getAttribute("data-loaded") === "true") return;

      pdfContainer.innerHTML = "";
      pdfContainer.setAttribute("data-loaded", "true");

      var loadPdfJs = window.ensurePdfJs
        ? window.ensurePdfJs()
        : Promise.resolve(window.pdfjsLib);

      loadPdfJs
        .then(function () {
          return pdfjsLib.getDocument(url).promise;
        })
        .then(function (pdfDoc) {
          const pageCount = pdfDoc.numPages;

          return pdfDoc.getPage(1).then(function (firstPage) {
            const unscaledViewport = firstPage.getViewport({ scale: 1 });
            const scale = computeScale(pdfContainer, containerWidth, unscaledViewport.width);
            const renderTasks = [];

            for (let pageNum = 1; pageNum <= pageCount; pageNum++) {
              renderTasks.push(
                pdfDoc.getPage(pageNum).then(function (page) {
                  const viewport = page.getViewport({ scale: scale });
                  const outputScale = window.devicePixelRatio || 1;
                  const canvas = document.createElement("canvas");
                  const context = canvas.getContext("2d", { alpha: false });

                  const cssWidth = Math.floor(viewport.width);
                  const cssHeight = Math.floor(viewport.height);

                  canvas.width = Math.floor(cssWidth * outputScale);
                  canvas.height = Math.floor(cssHeight * outputScale);
                  canvas.style.width = cssWidth + "px";
                  canvas.style.height = cssHeight + "px";
                  canvas.style.display = "block";
                  canvas.style.maxWidth = "100%";
                  canvas.className = "pdf-page-canvas";

                  pdfContainer.appendChild(canvas);

                  const transform =
                    outputScale !== 1
                      ? [outputScale, 0, 0, outputScale, 0, 0]
                      : null;

                  return page.render({
                    canvasContext: context,
                    viewport: viewport,
                    transform: transform,
                  }).promise;
                })
              );
            }

            return Promise.all(renderTasks);
          });
        })
        .catch(function (error) {
          console.error("Error loading PDF:", error);
          pdfContainer.removeAttribute("data-loaded");
        });
    }, 24);
  }

  // One binding per button: the marker survives re-runs of init() on the same markup.
  function bind(popupMain) {
    const pdfContainer = popupMain.querySelector(".pdf-container");
    const triggerBtn = popupMain.querySelector("button.text-with-popup-text");
    if (!pdfContainer || !triggerBtn) return false;
    if (triggerBtn.getAttribute("data-pdf-bound") === "true") return false;
    triggerBtn.setAttribute("data-pdf-bound", "true");
    triggerBtn.addEventListener("click", function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          renderPdfIfNeeded(popupMain, pdfContainer);
        });
      });
    });
    return true;
  }

  function init(root) {
    const scope = root && typeof root.querySelectorAll === "function" ? root : document;
    let bound = 0;
    scope.querySelectorAll(".text-with-popup-main[data-pdf-popup]").forEach(function (popupMain) {
      if (bind(popupMain)) bound++;
    });
    // Same preload layout/theme.liquid does for PDF anchors present at DOMContentLoaded.
    if (bound > 0 && typeof window.ensurePdfJs === "function") {
      window.ensurePdfJs().catch(function () {});
    }
    return bound;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener("deferred-section:loaded", function (event) {
    init((event.detail && event.detail.root) || event.target);
  });

  return { init: init };
})();

 


window.quickBUyCustomEvent = function(){
    console.log('yesss')
    const drawers = document.querySelectorAll('quick-buy-drawer');
    
    if (drawers.length > 0) {
      const lastDrawer = drawers[drawers.length - 1];
      console.log('Last drawer found:', lastDrawer);
      
      const cartButton = lastDrawer.querySelector('.cartButton');
      
      if (cartButton) {
        const cartIconLink = document.querySelector('.header__icon-list a[aria-controls="cart-drawer"]');

        if (cartButton && cartIconLink) {
          cartButton.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default navigation
            const CartDrawerAlreadyOpen = document.querySelector('cart-drawer.cart-drawer').hasAttribute('open');
            document.querySelector('cart-drawer.cart-drawer') && CartDrawerAlreadyOpen ? document.querySelector('cart-drawer.cart-drawer').click() : cartIconLink.click();   // Trigger the cart drawer
          });
        }
      } else {
        console.error('Cart button not found in the last drawer');
      }
    } else {
      console.error('No drawers found on the page');
    }
  }


const learnBtns = document.querySelectorAll('.custom-media-with-text .learn-more-btn button.button');
if (learnBtns.length > 0) {
  learnBtns.forEach(learnBtn => {
    learnBtn.addEventListener('click', () => {
      const mainWrapper = learnBtn.closest('.custom-media-with-text');
      if (!mainWrapper) return;
      const textCon = mainWrapper.querySelector('.mobile-text-con');
      if (!textCon) return;
      textCon.classList.toggle('hidden');
      const isHidden = textCon.classList.contains('hidden');
      learnBtn.textContent = isHidden ? 'Mehr erfahren' : 'Weniger erfahren';
    });
  });
}


// window.hideDuplicate = function () {
//   const seenIds = new Set();
//   document.querySelectorAll('.js-recommendation-cart').forEach(item => {
//   const productId = item.getAttribute('product-id');
//     if (seenIds.has(productId)) {
//       item.style.display = 'none';
//       const recommendationsContainer = item.closest('product-recommendations');
//       if (recommendationsContainer) {
//         recommendationsContainer.style.display = 'none';
//       }
//     } else {
//       seenIds.add(productId);
//     }
//   }); 
// }
// window.hideDuplicate();

// ----- Hero slider button animation ------
document.addEventListener("DOMContentLoaded", () => {
  const sliderPrevBtns = document.querySelectorAll('.custom-slideshow-sec button[is="prev-button"]');
  const sliderNextBtns = document.querySelectorAll('.custom-slideshow-sec button[is="next-button"]');

  function animatePrevButton(button) {
    button.style.transform = 'translateX(50px) translateY(-50%)';
    button.style.opacity = '0';
    setTimeout(() => {
      button.style.transform = 'translateX(0) translateY(-50%)';
      button.style.opacity = '1';
    }, 150);
  }

  function animateNextButton(button) {
    button.style.transform = 'translateX(-50px) translateY(-50%)';
    button.style.opacity = '0';
    setTimeout(() => {
      button.style.transform = 'translateX(0) translateY(-50%)';
      button.style.opacity = '1';
    }, 150);
  }

  sliderPrevBtns.forEach(button => {
    button.addEventListener("click", () => animatePrevButton(button));
  });

  sliderNextBtns.forEach(button => {
    button.addEventListener("click", () => animateNextButton(button));
  });
});

// ============ CART UPSELL SLIDER JS START HERE ============== //

window.MakeSliderOnCartUpsell = function () {
const sliderElement = document.querySelector('.js-upsell__sliders[data-slider-pagination]');
const enablePagination = sliderElement?.getAttribute('data-slider-pagination') === 'true';
  if (!sliderElement) return;

  // Kein Slider (und keine Punkte) bei nur einem Upsell-Produkt
  const itemCount = sliderElement.querySelectorAll('.custom-upsell__secitem').length;
  if (itemCount < 2) return;

  const options = {
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: enablePagination,
    draggable: true,
    groupCells: false,
    freeScroll: false,
  };

  new Flickity(sliderElement, options);
};

window.MakeSliderOnCartUpsell();

// ============ CART UPSELL SLIDER JS START HERE ============== //

// ============ GA4 tracking for contact section for PDP [Email, phone & date picker] ============== //

if(document.querySelector('.contact-icons-container .section_title h2')){  

const sectionTitle = document.querySelector('.contact-icons-container .section_title h2').innerText.trim();
const contact_items = document.querySelectorAll('.contact-icon-item');
contact_items.forEach(contactItem => {
  const contactLink = contactItem.querySelector('.contact_content a[href]');  
  if (contactLink) {
    contactLink.addEventListener('click', function(event) {
      const linkItem = this.href;
      const linkLabel = this.closest('.contact_content').querySelector('p.h4').innerText.trim();      
      const linkParent = this.closest('.contact-icon-item').className || 'contact-icon-item';
      
      const dataLayerObj = {
        event: 'contact_link_click',
        section_title: sectionTitle,
        target_item: linkItem,
        target_type: linkLabel
      };
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerObj);
      console.log('DataLayer push:', dataLayerObj);
    });
  }
});
}


// ============ SEARCH bAR ADD CLASS AND REMOVE CLASS BODY CLASS ============== //

document.addEventListener('DOMContentLoaded', function () {
  
    
    // Add class to body
    // document.body.classList.add('search-drawer-open');

    // Add 'open' attribute to all .search-drawer elements
    const searchDrawers = document.querySelectorAll('.search-drawer');
    searchDrawers.forEach(drawer => {
      if(window.innerWidth > 1149){
        document.body.classList.add('search-drawer-open');
        drawer.setAttribute('open', true);
      } else {
        if(drawer.hasAttribute('open')){
          document.body.classList.add('search-drawer-open');
        }
      }
    });

  // Optional: Add click listeners to open/close the drawer
  document.querySelectorAll('.custom-search__icon').forEach(icon => {
    icon.addEventListener('click', function () {
      // document.body.classList.add('search-drawer-open');
    });
  });

  document.querySelectorAll('search-drawer button[is="close-button"]').forEach(button => {
    button.addEventListener('click', function () {
      // document.body.classList.remove('search-drawer-open');
    });
  });
  

});
// ============ SEARCH bAR ADD CLASS AND REMOVE CLASS BODY CLASS ============== //

// ============ ADD AND REMOVE CLASS IN BODY WHEN MOBILE MENU OPENS ============== //

document.addEventListener('DOMContentLoaded', function () {
    const toggleMenu = document.querySelector('.toggle-menu');
    if (toggleMenu) {
        toggleMenu.addEventListener('click', function () {
            const bodyElement = document.querySelector('body');
            if (bodyElement.classList.contains('menu-drawer-open')) {
                setTimeout(() => {
                    bodyElement.classList.remove('menu-drawer-open');
                }, 100);
            } else {
                bodyElement.classList.add('menu-drawer-open');
            }
        });
    }

    // Handle navigation drawer events
    const navigationDrawers = document.querySelectorAll('navigation-drawer');
    navigationDrawers.forEach(drawer => {
        // Listen for the dialog:after-show event
        drawer.addEventListener('dialog:after-show', function() {
            document.body.classList.add('menu-drawer-open');
        });

        // Listen for the dialog:after-hide event
        drawer.addEventListener('dialog:after-hide', function() {
            setTimeout(() => {
                document.body.classList.remove('menu-drawer-open');
            }, 100);
        });
    });
});

window.initEmptySlider = function(){
  var swiperContainer = document.querySelector(".custom-carousel__sliderwrapper");
    // Initialize Swiper instance
    var mySwiper = new Swiper(swiperContainer, {
       // slidesPerView: 3,
      slidesPerView: "auto",
      
      loop: false,
      // loopAdditionalSlides: 30,
      spaceBetween: 20,
  
    });
}
window.initEmptySlider();



document.addEventListener("DOMContentLoaded", function () {
  const searchDrawers = document.querySelectorAll(".search-drawer");

  searchDrawers.forEach((searchDrawer) => {
    const input = searchDrawer.querySelector('input[type="search"]');
    const clearButton = searchDrawer.querySelector('button[type="reset"]');
    const closeButton = searchDrawer.querySelector('button[is="close-button"]');

    // Safety check
    if (!input || !clearButton || !closeButton) return;

    function openDrawer() {
      searchDrawer.classList.add("search-drawer__active");
      document.documentElement.style.overflow = "hidden"; // disable scroll on <html>
    }

    function closeDrawer() {
      searchDrawer.classList.remove("search-drawer__active");
      document.documentElement.style.overflow = ""; // restore scroll on <html>
    }

    function focusOut(evt) {
      if (!searchDrawer.contains(evt.target)) {
        closeDrawer();
      }
    }

    function updateDrawerClass() {
      // Optional logic to change classes based on input, if needed
    }

    // Input focus opens drawer
    input.addEventListener("focus", (event) => {
      if (
        event.relatedTarget != null &&
        event.relatedTarget.getAttribute("type") === "reset"
      ) return;

      openDrawer();
    });

    // Input typing (optional logic)
    input.addEventListener("input", updateDrawerClass);

    // Clicking outside drawer closes it
    document.addEventListener("click", focusOut);

    // Clear button
    clearButton.addEventListener("click", function () {
      if (input.value.length > 0) {
        input.value = "";
      } else {
        closeDrawer();
        setTimeout(() => {
          input.blur();
        });
      }
    });

    // Close button
    closeButton.addEventListener("click", function () {
      closeDrawer();
    });
  });
});


// Custom Comp Product Popup Js
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".openPopupBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);
      if (popup) popup.classList.remove("hidden");
      document.body.classList.add('custom-popup__open');
    });
  });
  document.querySelectorAll(".closePopupBtn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      const popupId = this.getAttribute("data-popup-id");
      const popup = document.getElementById(popupId);
      if (popup) popup.classList.add("hidden");
        document.body.classList.remove('custom-popup__open');
      });
  });
});
// Custom Comp Product Popup Js


// ============ GA4 tracking for contact section for PDP [Email, phone & date picker] ============== //

if(document.querySelector('.contact-icons-container .section_title h2')){  
const sectionTitle = document.querySelector('.contact-icons-container .section_title h2').innerText.trim();
const contact_items = document.querySelectorAll('.contact-icon-item');
contact_items.forEach(contactItem => {
  const contactLink = contactItem.querySelector('.contact_content a[href]');  
  if (contactLink) {
    contactLink.addEventListener('click', function(event) {
      const linkItem = this.href;
      const linkLabel = this.closest('.contact_content').querySelector('p.h4').innerText.trim();      
      const linkParent = this.closest('.contact-icon-item').className || 'contact-icon-item';
      
      const dataLayerObj = {
        event: 'contact_link_click',
        section_title: sectionTitle,
        target_item: linkItem,
        target_type: linkLabel
      };
      
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayerObj);
      console.log('DataLayer push:', dataLayerObj);
    });
  }
});
}



var currentVariantJson = '';
var additionalVariantJson = '';

function attachAdditionalVariant(){
  const mainWrapper = document.querySelector('.product-info');
  const additional_variant_container = mainWrapper?.querySelector('.additional-variant-option');
  if(mainWrapper && additional_variant_container){
    const additionalProductVariantJson = mainWrapper.querySelector('.additional_product_variant_json');
    if(additionalProductVariantJson){
      additionalVariantJson = JSON.parse(additionalProductVariantJson.textContent);
    }
    const currentProductVariantJson = mainWrapper.querySelector('.current_variant_json');
    if(currentProductVariantJson){
      currentVariantJson = JSON.parse(currentProductVariantJson.textContent);
    }
    document.addEventListener('variant:change',(evt)=>{
      currentVariantJson = evt.detail.variant;
      updatePrice(mainWrapper);
    });
    document.addEventListener('additional_variant:change',(evt)=>{
      additionalVariantJson = evt.detail.variant;
      updatePrice(mainWrapper);
    });
  }
}

attachAdditionalVariant();

function updatePrice (mainWrapper){
  // console.log(currentVariantJson);
  // console.log(additionalVariantJson);
  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;
  const currentVariantPrice = parseFloat(currentVariantJson.price);
  const additionalVariantPrice = parseFloat(additionalVariantJson.price);
  const totalPrice = currentVariantPrice + additionalVariantPrice;
  const mainPriceWrapper = mainWrapper.querySelector('sale-price');
  if(mainPriceWrapper){
    mainPriceWrapper.innerHTML = `<span class="sr-only">Angebot</span> ${formatMoney(totalPrice, currencyFormat)}`;
  }
  
}


$(document).ready(function() {
    // Heights calculate karna
    var deskscreenHeight = $('.shopify-section-group-header-group .deskscreen').outerHeight();
    var headerWrapperHeight = $('.header__wrapper').outerHeight();

    // Heights ko add karna
    var totalHeight = deskscreenHeight + headerWrapperHeight;

    // Navigation drawer ka top adjust karna
    $('navigation-drawer').css('top', totalHeight + 'px');
});


document.addEventListener("DOMContentLoaded", function () {
  const targetSelector = ".custom-header__groupwrapper";

  // Function to calculate height and set CSS variable
  const setHeaderHeight = () => {
    const el = document.querySelector(targetSelector);
    if (el) {
      const height = el.offsetHeight;

      if (height > 0) {
        // Set the custom CSS variable
        document.documentElement.style.setProperty('--header-height', `${height}px`);
        console.log(`Height of ${targetSelector}: ${height}px → set as --header-height`);
        return true;
      }
    }
    return false;
  };

  // MutationObserver to detect when the target appears in the DOM
  const observer = new MutationObserver(() => {
    if (setHeaderHeight()) {
      observer.disconnect(); // Stop observing once successful
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Fallback: interval polling
  const intervalId = setInterval(() => {
    if (setHeaderHeight()) {
      clearInterval(intervalId);
      observer.disconnect(); // Clean up observer too
    }
  }, 300);

  // Optional: update variable on window resize
  window.addEventListener('resize', () => {
    setHeaderHeight();
  });
});

// $(document).ready(function () {
//   var $deskscreen = $('.new-custom__announcement');
//   var isHidden = false;

//   $(window).on('scroll', function () {
//     var scrollTop = $(this).scrollTop();
//     var headerHeight = $deskscreen.outerHeight(true);

//     if (scrollTop > 10 && !isHidden) {
//       $deskscreen.stop().animate({
//         marginTop: -headerHeight,
//         opacity: 0
//       }, 300);
//       isHidden = true;
//     } else if (scrollTop <= 10 && isHidden) {
//       $deskscreen.stop().animate({
//         marginTop: 0,
//         opacity: 1
//       }, 300);
//       isHidden = false;
//     }
//   });
// });
// $(document).ready(function () {
//   var $announcement = $('.new-custom__announcement');
//   var $headerWrapper = $('.custom-header__groupwrapper');
//   var isHidden = false;

//   function updatePosition() {
//     var announcementHeight = $announcement.outerHeight(true);

//     if ($(window).scrollTop() > 10) {
//       $announcement.stop().animate({
//         marginTop: -announcementHeight,
//         opacity: 0
//       }, 300);

//       $headerWrapper.css({
//         // position: 'relative',
//         top: -announcementHeight + 'px'
//       });

//       isHidden = true;
//     } else {
//       $announcement.stop().animate({
//         marginTop: 0,
//         opacity: 1
//       }, 300);

//       $headerWrapper.css({
//         // position: 'relative',
//         top: '0px'
//       });

//       isHidden = false;
//     }
//   }

//   // Scroll Event
//   $(window).on('scroll', function () {
//     updatePosition();
//   });

//   // Resize Event – recalculate announcement height
//   $(window).on('resize', function () {
//     if (isHidden) {
//       var announcementHeight = $announcement.outerHeight(true);
//       $headerWrapper.css({
//         top: -announcementHeight + 'px'
//       });
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   window.addEventListener('scroll', function() {
//     if (window.scrollY > 20) {
//         document.body.classList.add('header_stickey');
//       console.log('element found');
//     } else {
//         document.body.classList.remove('header_stickey');
//       console.log('element Not found');
//     }
//   });
// });

// $(document).ready(function () {
//   var $announcement = $('.new-custom__announcement');
//   var $headerWrapper = $('.custom-header__groupwrapper');
//   var isHidden = false;

//   function getAccurateHeight($el) {
//     // Temporarily reset styles to measure real height
//     var originalStyles = {
//       display: $el.css('display'),
//       opacity: $el.css('opacity'),
//       position: $el.css('position'),
//       visibility: $el.css('visibility')
//     };

//     $el.css({
//       display: 'block',
//       opacity: 1,
//       // position: 'absolute',
//       visibility: 'hidden'
//     });

//     var height = $el.outerHeight(true);

//     // Restore original styles
//     $el.css(originalStyles);

//     return height;
//   }

//   function updatePosition() {
//     var scrollTop = $(window).scrollTop();
//     var announcementHeight = getAccurateHeight($announcement);

//     if (scrollTop > 50 && !isHidden) {
//       $announcement.stop().animate({
//         marginTop: -announcementHeight,
//         // opacity: 0
//       }, 300);

//       $headerWrapper.css({
//         // position: 'relative',
//         top: -announcementHeight + 'px'
//       });

//       isHidden = true;
//     } else if (scrollTop <= 50 && isHidden) {
//       $announcement.stop().animate({
//         marginTop: 0,
//         opacity: 1
//       }, 300);

//       $headerWrapper.css({
//         top: '0px'
//       });

//       isHidden = false;
//     }
//   }

//   // Scroll
//   $(window).on('scroll', updatePosition);

//   // Resize (recalculate if still hidden)
//   $(window).on('resize', function () {
//     if (isHidden) {
//       var announcementHeight = getAccurateHeight($announcement);
//       $headerWrapper.css({
//         top: -announcementHeight + 'px'
//       });
//     }
//   });
// });



// document.addEventListener('additional_variant:change',(evt)=>{
//   console.log(evt.detail.variant.id);
// })


const checkNav = () => {
  const body = document.querySelector('.as-bs-0003');

  const hasBubble = body.querySelector('.bubble_item');
  const hasCollectionNav = body.querySelector('.collection__nav');

  if (!hasBubble && !hasCollectionNav) {
    body.classList.add('no-bubble-or-nav');
  }
};

const updateNav = () => {
    //Nav with bubble_items
    document.querySelectorAll('.shopify-section:has(.bubble_item) .bubble_item').forEach((item) => {
      item.addEventListener('click', (event) => {
        if (!event.target.closest('a')) {
          console.log('test');
          item.querySelector('a').click();
        }
      });
    });

    //Nav with collection__nav__item
    /*document.querySelectorAll('.shopify-section:has(.collection__nav__list) .collection__nav__item').forEach((item) => {
      item.addEventListener('click', (event) => {
        if (!event.target.closest('a')) {
          console.log('test 1');
          item.querySelector('a').click();
        }
      });
    });
  };*/

	document.querySelectorAll('.shopify-section:has(.collection__nav__list) .collection__nav__item').forEach((item) => {
      console.log('ab_code_updated.');
      item.addEventListener('click', (event) => {
        console.log('test 1');
        document.querySelectorAll('.shopify-section:has(.collection__nav__list) .collection__nav__item').forEach((_item) => {
          if(_item.classList.contains('collection__nav__item--active')) _item.classList.remove('collection__nav__item--active');
		})
        item.classList.add('collection__nav__item--active');
        const id = item.querySelector('div').getAttribute('data-href').split("#")[1];
        const target = document.getElementById(id);
        if (!target) return;
        const headerOffset = 80; // px of your fixed header
        const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        target.scrollIntoView({ top, behavior: 'smooth', inline: 'nearest' });
      });
    });
  };

   //Custom padding for Pages wit collection__nav cause they are build different
  const navPadding = () => {
    const navList = document.querySelector('.shopify-section:has(.collection__nav__list)');
    if (navList) {
      const padding = document.querySelector('.section.section-blends.section-full:has(.floating-controls-container)');
      const target = navList.querySelector('.url-tabs');

      const styles = getComputedStyle(padding);
      target.style.paddingLeft = styles.paddingLeft;
      target.style.paddingRight = styles.paddingRight;
    }
  };

  //Hide old badges
  const hideoldBadges = () => {
    document.querySelectorAll('.shopify-section.logo_image_marquee').forEach((section) => {
      const h3 = section.querySelector('h3');
      if (h3 && h3.textContent.trim() === 'Bekannt aus:') {
        section.style.display = 'none';
      }
    });
  };

function CategoryPageHeaderGestaltungOptimierenVariation(){
  if(!document.body.classList.contains('as-bs-0003')) document.body.classList.add('as-bs-0003');
  checkNav();
  updateNav();
  navPadding();
  hideoldBadges();
  window.addEventListener('resize', navPadding);
}





let elementsToHide = [];

function toggleElementsVisibility() {
  if (window.scrollY > 50) {
    elementsToHide.forEach(el => {
        if (el) el.style.display = 'none';
    });
  } else {
    elementsToHide.forEach(el => {
        if (el) el.style.display = '';
    });
  }
}

const maxAttempts = 25;
let currentAttempt = 0;
const intervalTime = 1000;

const pollInterval = setInterval(() => {
  currentAttempt++;
  
  const foundElements = document.querySelectorAll('[id*="trustbadge-container-"]');
  
  if (foundElements.length > 0) {
    elementsToHide = Array.from(foundElements);
    clearInterval(pollInterval);
    
    window.addEventListener('scroll', toggleElementsVisibility);
    
    toggleElementsVisibility();
    
    return;
  }
  
  if (currentAttempt >= maxAttempts) {
      clearInterval(pollInterval);
  }
}, intervalTime);



//// Equal height Js 
function equalizeTitleHeights() {
  const titles = document.querySelectorAll('.custom-product-card__title');
  let maxHeight = 0;

  // Reset heights
  titles.forEach(t => t.style.height = 'auto');

  // Find the tallest title
  titles.forEach(t => {
    const height = t.offsetHeight;
    if (height > maxHeight) maxHeight = height;
  });

  // Apply the same height
  titles.forEach(t => t.style.height = `${maxHeight}px`);
}

// Run when DOM is ready
document.addEventListener('DOMContentLoaded', equalizeTitleHeights);
window.addEventListener('resize', equalizeTitleHeights);

(function() {
  'use strict';

  const COLLECTION_FILTER_TRACKING = {
    trackingInitialized: false,
    
    init() {
      if (!this.isCollectionOrSearchPage()) return;
      
      if (!this.trackingInitialized) {
        this.trackFilterChanges();
        this.trackActiveFacetRemoval();
        this.trackClearAllFilters();
        this.trackSortByChanges();
        this.trackingInitialized = true;
      }
      
      this.observePageChanges();
    },
    
    observePageChanges() {
      const observer = new MutationObserver(() => {
        const forms = document.querySelectorAll('form[is="facet-form"]');
        forms.forEach(form => {
          if (!form.dataset.trackingAttached) {
            this.attachFormTracking(form);
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    },

    isCollectionOrSearchPage() {
      return document.querySelector('form[is="facet-form"]') !== null;
    },

    getPageType() {
      return window.location.pathname.includes('/search') ? 'search' : 'collection';
    },

    getFilterLayout() {
      const collectionElement = document.querySelector('.collection');
      if (!collectionElement) return 'unknown';

      if (collectionElement.classList.contains('collection--filters-horizontal')) {
        return 'horizontal';
      } else if (collectionElement.classList.contains('collection--filters-sidebar')) {
        return 'sidebar';
      } else if (collectionElement.classList.contains('collection--filters-drawer')) {
        return 'drawer';
      }
      return 'unknown';
    },

    pushToDataLayer(eventData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    },

    getFilterTypeFromParamName(paramName) {
      if (paramName.includes('filter.v.price')) return 'Price';
      if (paramName.includes('filter.v.availability')) return 'Availability';
      
      if (paramName.includes('filter.p.m.custom.')) {
        const filterName = paramName.replace('filter.p.m.custom.', '');
        const cleanName = filterName.replace('filter_', '').replace(/_/g, ' ');
        return cleanName.charAt(0).toUpperCase() + cleanName.slice(1);
      }
      
      if (paramName.includes('filter.p.')) {
        const parts = paramName.split('.');
        const filterName = parts[parts.length - 1] || 'Unknown';
        return filterName.replace('filter_', '').replace(/_/g, ' ');
      }
      
      return paramName.replace('filter.', '').replace('v.', '').replace('p.', '').replace(/_/g, ' ');
    },

    trackFilterChanges() {
      const facetForms = document.querySelectorAll('form[is="facet-form"]');
      if (facetForms.length === 0) return;


      facetForms.forEach((facetForm) => {
        this.attachFormTracking(facetForm);
      });
    },
    
    attachFormTracking(facetForm) {
      if (facetForm.dataset.trackingAttached) return;
      
      facetForm.dataset.trackingAttached = 'true';
      
      facetForm.addEventListener('change', (event) => {
        const target = event.target;
        let filterType = 'Unknown';
        let filterValue = '';
        let filterAction = 'apply';


        if (target.type === 'checkbox' && !target.classList.contains('switch')) {
          const checkbox = target;
          
          let label = checkbox.closest('label')?.textContent?.trim() || '';
          if (!label) {
            const labelElement = document.querySelector(`label[for="${checkbox.id}"]`);
            label = labelElement ? labelElement.textContent.trim() : '';
          }
          
          filterValue = label.replace(/\(\d+\)$/, '').trim();
          filterAction = checkbox.checked ? 'apply' : 'remove';


          const accordion = checkbox.closest('.accordion, details, [class*="accordion"]');
          
          if (accordion) {
            const accordionTitle = accordion.querySelector('.accordion__toggle, summary, [slot="summary"]');
            
            if (accordionTitle) {
              const rawTitle = accordionTitle.textContent;
              
              filterType = rawTitle.trim();
              const firstLineBreak = filterType.indexOf('\n');
              if (firstLineBreak > 0) {
                filterType = filterType.substring(0, firstLineBreak).trim();
              }
            }
          } else {
            const checkboxList = checkbox.closest('.checkbox-list');
            if (checkboxList) {
              const parentAccordion = checkboxList.parentElement?.closest('.accordion, details, [role="group"]');
              if (parentAccordion) {
                const title = parentAccordion.querySelector('.accordion__toggle, summary, [slot="summary"]');
                if (title) {
                  filterType = title.textContent.trim().split('\n')[0];
                  console.log('  - Found via parent search:', filterType);
                }
              }
            }
          }

          if (filterType === 'Unknown' && checkbox.name) {
            filterType = this.getFilterTypeFromParamName(checkbox.name);
          }
        }
        else if (target.classList.contains('switch')) {
          const switchInput = target;
          const switchLabel = switchInput.closest('.accordion__toggle')?.querySelector('label');
          if (switchLabel) {
            filterType = switchLabel.textContent.trim();
          } else if (switchInput.name) {
            filterType = this.getFilterTypeFromParamName(switchInput.name);
          }
          filterValue = switchInput.checked ? 'enabled' : 'disabled';
          filterAction = switchInput.checked ? 'apply' : 'remove';
        }
        else if (target.type === 'radio') {
          const radioLabel = target.closest('label')?.textContent?.trim();
          filterValue = radioLabel || '';
          filterType = 'Sort By';
          filterAction = 'apply';
        }
        else if (target.type === 'number' || target.type === 'range') {
          const priceInputs = facetForm.querySelectorAll('input[name*="filter.v.price"]');
          const minPrice = Array.from(priceInputs).find(input => input.name.includes('gte'))?.value || '0';
          const maxPrice = Array.from(priceInputs).find(input => input.name.includes('lte'))?.value || 'max';
          filterType = 'Price';
          filterValue = `${minPrice}-${maxPrice}`;
          filterAction = 'apply';
        }

        if (filterType && filterValue) {
          this.pushToDataLayer({
            event: 'filter_applied',
            filter_type: filterType,
            filter_value: filterValue,
            filter_action: filterAction,
            filter_layout: this.getFilterLayout(),
            page_type: this.getPageType()
          });
        } else {
        }
      });
    },

    trackActiveFacetRemoval() {
      document.addEventListener('click', (event) => {
        const facetLink = event.target.closest('a[is="facet-link"]');
        if (!facetLink) return;

        const removableFacet = facetLink.closest('.removable-facet');
        if (removableFacet) {
          const facetText = removableFacet.textContent.trim();
          let filterType = 'Unknown';
          let filterValue = facetText;

          if (facetText.includes(':')) {
            const parts = facetText.split(':');
            filterType = parts[0].trim();
            filterValue = parts[1].trim();
          }

          this.pushToDataLayer({
            event: 'filter_applied',
            filter_type: filterType,
            filter_value: filterValue,
            filter_action: 'remove',
            filter_layout: this.getFilterLayout(),
            page_type: this.getPageType()
          });
        }
      });
    },

    trackClearAllFilters() {
      document.addEventListener('click', (event) => {
        const clearAllLink = event.target.closest('.facet-clear-all');
        if (!clearAllLink) return;

        this.pushToDataLayer({
          event: 'filter_applied',
          filter_type: 'All Filters',
          filter_value: 'clear_all',
          filter_action: 'clear_all',
          filter_layout: this.getFilterLayout(),
          page_type: this.getPageType()
        });
      });
    },

    trackSortByChanges() {
      const sortByElement = document.querySelector('facet-sort-by');
      if (!sortByElement) return;

      sortByElement.addEventListener('listbox:change', (event) => {
        const selectedOption = event.target.querySelector('[aria-selected="true"]')?.textContent?.trim();

        if (selectedOption) {
          this.pushToDataLayer({
            event: 'filter_applied',
            filter_type: 'Sort By',
            filter_value: selectedOption,
            filter_action: 'apply',
            filter_layout: this.getFilterLayout(),
            page_type: this.getPageType()
          });
        }
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => COLLECTION_FILTER_TRACKING.init());
  } else {
    COLLECTION_FILTER_TRACKING.init();
  }
})();

document.addEventListener("DOMContentLoaded", function () {
  const checkIframe = setInterval(() => {
    const iframe = document.querySelector('.klarna-text.paypal_text iframe');
    if (!iframe) return;

    clearInterval(checkIframe);

    const forcePointerEvents = () => {
      const computed = window.getComputedStyle(iframe);

      if (computed.pointerEvents === 'none') {
        iframe.style.setProperty('pointer-events', 'auto', 'important');
      }
    };

    // Run once initially
    forcePointerEvents();

    // Watch for PayPal changing styles later
    const observer = new MutationObserver(forcePointerEvents);
    observer.observe(iframe, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });

  }, 300); // wait until iframe exists
});


// const allSortByForms = document.querySelectorAll('facet-sort-by');
// if(allSortByForms.length > 0){
//   allSortByForms.forEach(sort_by=>{
//     const best_selling_option = sort_by.querySelector('.popover-listbox__option[value="best-selling"]');
//     if(best_selling_option){
//       sort_by.dispatchEvent(new CustomEvent("listbox:change", {
//         bubbles: true,
//         detail: {
//           value: best_selling_option.value
//         }
//       }))
//     }
//   })
// }

if (!window.location.pathname.includes('balkonkraftwerke-mit-speicher')) {
  const allSortByForms = document.querySelectorAll('facet-sort-by');
  if (allSortByForms.length > 0) {
    allSortByForms.forEach(sort_by => {
      const bestSelling = sort_by.querySelector('[value="manual"]');
      if (bestSelling) {
        sort_by.dispatchEvent(new CustomEvent("listbox:change", {
          bubbles: true,
          detail: {
            value: bestSelling.value
          }
        }));
      }
    });
  }
}

function equalTitleHeight() {
  // Sab title elements select karo
  const titles = document.querySelectorAll(
    '.New-Updated__design .collection__results reveal-items product-list.product-list product-card .product-card__info .v-stack span.product-card__title'
  );

  let rowTop = 0;
  let rowItems = [];
  let maxHeight = 0;

  // Pehle sabki height reset karo
  titles.forEach(el => {
    el.style.height = "auto";
  });

  titles.forEach(el => {
    const topPosition = el.getBoundingClientRect().top;

    if (rowTop !== topPosition) {
      // Previous row ke items ko height apply karo
      rowItems.forEach(item => {
        item.style.height = maxHeight + "px";
      });

      // Reset for new row
      rowItems = [];
      rowTop = topPosition;
      maxHeight = 0;
    }

    rowItems.push(el);
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // Last row ke liye
  rowItems.forEach(item => {
    item.style.height = maxHeight + "px";
  });
}

// Page load par run karo
window.addEventListener("load", equalTitleHeight);

// Resize par bhi run karo
window.addEventListener("resize", function() {
  setTimeout(equalTitleHeight, 200);
});

function EQualHeightReviews() {
  const items = document.querySelectorAll(
    '.New-Updated__design .collection__results .jdgm-widget'
  );

  let currentRowTop = 0;
  let rowItems = [];
  let maxHeight = 0;

  // Reset heights
  items.forEach(el => {
    el.style.height = "auto";
  });

  items.forEach(el => {
    const topPosition = el.getBoundingClientRect().top;

    if (currentRowTop !== topPosition) {
      // Apply height to previous row
      rowItems.forEach(item => {
        item.style.height = maxHeight + "px";
      });

      // Reset for new row
      rowItems = [];
      currentRowTop = topPosition;
      maxHeight = 0;
    }

    rowItems.push(el);
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // Apply height to last row
  rowItems.forEach(item => {
    item.style.height = maxHeight + "px";
  });
}

// Run on load
window.addEventListener("load", function () {
  EQualHeightReviews();
});

// Run on resize
window.addEventListener("resize", function () {
  setTimeout(EQualHeightReviews, 200);
});














function UpdateCollectionTitleHeight() {
  // Sab title elements select karo
  const titles = document.querySelectorAll(
    '.custom-product-card__title'
  );

  let rowTop = 0;
  let rowItems = [];
  let maxHeight = 0;

  // Pehle sabki height reset karo
  titles.forEach(el => {
    el.style.height = "auto";
  });

  titles.forEach(el => {
    const topPosition = el.getBoundingClientRect().top;

    if (rowTop !== topPosition) {
      // Previous row ke items ko height apply karo
      rowItems.forEach(item => {
        item.style.height = maxHeight + "px";
      });

      // Reset for new row
      rowItems = [];
      rowTop = topPosition;
      maxHeight = 0;
    }

    rowItems.push(el);
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // Last row ke liye
  rowItems.forEach(item => {
    item.style.height = maxHeight + "px";
  });
}

// Page load par run karo
window.addEventListener("load", UpdateCollectionTitleHeight);

// Resize par bhi run karo
window.addEventListener("resize", function() {
  setTimeout(UpdateCollectionTitleHeight, 200);
});


// function UpdateCollectionReviewHeight() {
//   const items = document.querySelectorAll(
//     '.custom-product-card__reviews'
//   );

//   let currentRowTop = 0;
//   let rowItems = [];
//   let maxHeight = 0;

//   // Reset heights
//   items.forEach(el => {
//     el.style.height = "auto";
//   });

//   items.forEach(el => {
//     const topPosition = el.getBoundingClientRect().top;

//     if (currentRowTop !== topPosition) {
//       // Apply height to previous row
//       rowItems.forEach(item => {
//         item.style.height = maxHeight + "px";
//       });

//       // Reset for new row
//       rowItems = [];
//       currentRowTop = topPosition;
//       maxHeight = 0;
//     }

//     rowItems.push(el);
//     maxHeight = Math.max(maxHeight, el.offsetHeight);
//   });

//   // Apply height to last row
//   rowItems.forEach(item => {
//     item.style.height = maxHeight + "px";
//   });
// }

// Run on load
// window.addEventListener("load", function () {
//   UpdateCollectionReviewHeight();
// });

// // Run on resize
// window.addEventListener("resize", function () {
//   setTimeout(UpdateCollectionReviewHeight, 200);
// });




// document.addEventListener("DOMContentLoaded", function () {
//   var descriptions = document.querySelectorAll(".custom-product-card__desc");

//   descriptions.forEach(function(desc) {
//     if (desc.textContent.trim() === "") {
//       desc.style.display = "none";
//     }
//   });
// });


function handleReviews() {
  const reviewBlocks = document.querySelectorAll('.custom-product-card__reviews');

  let maxHeight = 0;

  // Step 1: Hide empty & reset height
  reviewBlocks.forEach(el => {
    el.style.display = 'block';
    el.style.height = 'auto';

    if (el.textContent.trim() === '') {
      el.style.display = 'none';
    } else {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    }
  });

  // Step 2: Apply equal height
  reviewBlocks.forEach(el => {
    if (el.style.display !== 'none') {
      el.style.height = maxHeight + 'px';
    }
  });
}

// Run on load
window.addEventListener('load', handleReviews);

// Run on resize
window.addEventListener('resize', () => {
  handleReviews();
});


function equalizeDescHeight() {
  const items = document.querySelectorAll(
    '.New-Updated__design .collection__results reveal-items product-list.product-list product-card .product-card__info .v-stack .custom-product-card__desc.updated-desc'
  );

  let maxHeight = 0;

  // reset + calculate
  items.forEach(el => {
    el.style.height = 'auto';
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  // apply max height
  items.forEach(el => {
    el.style.height = maxHeight + 'px';
  });
}

// run on load
window.addEventListener('load', equalizeDescHeight);

// run on resize
window.addEventListener('resize', equalizeDescHeight);



document.addEventListener("DOMContentLoaded", function () {
  const disabledPopups = document.querySelectorAll(".disable_shipping_infopopup");

  disabledPopups.forEach(function (el) {
    const popupWrapper = el.closest("[data-popup-target]");
    if (popupWrapper) {
      popupWrapper.removeAttribute("data-popup-target");
    }
  });
});


// // height gat filter 

function updateCollectionTopBarOffset() {
  const usp = document.querySelector('.usp-announcement');
  const deskscreen = document.querySelector('.deskscreen');
  const header = document.querySelector('header');

  const uspHeight = usp ? usp.offsetHeight : 0;
  const deskscreenHeight = deskscreen ? deskscreen.offsetHeight : 0;
  const headerHeight = header ? header.offsetHeight : 0;

  const totalHeight = uspHeight + deskscreenHeight + headerHeight + 5;

  document.querySelectorAll('.collection__top-bar').forEach((el) => {
    el.style.top = `${totalHeight}px`;
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', updateCollectionTopBarOffset);

// Window resize
window.addEventListener('resize', updateCollectionTopBarOffset);


function updateFacetFilterTop() {
  const usp = document.querySelector('.usp-announcement');
  const deskscreen = document.querySelector('.deskscreen');
  const header = document.querySelector('header');

  const uspHeight = usp ? usp.offsetHeight : 0;
  const deskscreenHeight = deskscreen ? deskscreen.offsetHeight : 0;
  const headerHeight = header ? header.offsetHeight : 0;

  const totalHeight = uspHeight + deskscreenHeight + headerHeight + 5;

  const facetFilter = document.querySelector('facet-floating-filter.facets__floating-filter');

  if (facetFilter) {
    facetFilter.style.position = 'sticky';
    facetFilter.style.top = `${totalHeight}px`;
    facetFilter.style.zIndex = '99';
  }
}

document.addEventListener('DOMContentLoaded', updateFacetFilterTop);
window.addEventListener('resize', updateFacetFilterTop);
window.addEventListener('scroll', updateFacetFilterTop);


document.addEventListener('DOMContentLoaded', function () {

  function equalizeProductTitleHeight() {
    const titles = Array.from(document.querySelectorAll('.product-card__title'));

    if (!titles.length) return;

    // Reset all heights first
    titles.forEach(function (title) {
      title.style.height = 'auto';
    });

    // Group titles by row
    const rows = {};

    titles.forEach(function (title) {
      const top = Math.round(title.getBoundingClientRect().top);

      if (!rows[top]) {
        rows[top] = [];
      }

      rows[top].push(title);
    });

    // Set same height for each row
    Object.keys(rows).forEach(function (top) {
      const rowTitles = rows[top];

      let maxHeight = 0;

      rowTitles.forEach(function (title) {
        maxHeight = Math.max(maxHeight, title.offsetHeight);
      });

      rowTitles.forEach(function (title) {
        title.style.height = maxHeight + 'px';
      });
    });
  }

  // Initial load
  equalizeProductTitleHeight();

  // Resize
  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      equalizeProductTitleHeight();
    }, 100);
  });

}); 


document.addEventListener('DOMContentLoaded', function () {
  const SEARCH_TITLE_SELECTOR = 'product-card .product-card__title';
  const SEARCH_LIST_SELECTOR = '.cs_custom_recommended_products_list product-list, predictive-search [slot="results"] product-list, search-drawer [slot="results"] product-list';
  const observedLists = new WeakSet();
  let listResizeTimer;

  function resetSearchbarTitleHeights(titles) {
    titles.forEach(function (title) {
      title.style.height = '';
      title.style.minHeight = '';
    });
  }

  function isSearchOpen() {
    const drawer = document.querySelector('search-drawer.search-drawer, search-drawer, .search-drawer');

    if (!drawer) return false;

    return drawer.classList.contains('search-drawer__active') || drawer.hasAttribute('open');
  }

  function isElementVisible(el) {
    if (!el || el.hidden) return false;
    if (el.offsetWidth === 0 && el.offsetHeight === 0) return false;
 
    const style = window.getComputedStyle(el);

    if (style.display === 'none' || style.visibility === 'hidden' || parseFloat(style.opacity) === 0) {
      return false;
    }

    return el.getClientRects().length > 0;
  }

  function queryAllDeep(root, selector) {
    const matches = [];

    if (!root) return matches;

    if (root.querySelectorAll) {
      matches.push.apply(matches, root.querySelectorAll(selector));
    }

    const children = root.querySelectorAll ? root.querySelectorAll('*') : [];

    children.forEach(function (node) {
      if (node.shadowRoot) {
        matches.push.apply(matches, queryAllDeep(node.shadowRoot, selector));
      }
    });

    if (root.shadowRoot) {
      matches.push.apply(matches, queryAllDeep(root.shadowRoot, selector));
    }

    return matches;
  }

  function uniqueNodes(nodes) {
    return Array.from(new Set(nodes));
  }

  function getSearchProductLists() {
    const roots = document.querySelectorAll('search-drawer, .search-drawer, predictive-search');
    let lists = Array.from(document.querySelectorAll(SEARCH_LIST_SELECTOR));

    roots.forEach(function (root) {
      lists = lists.concat(queryAllDeep(root, 'product-list'));
    });

    return uniqueNodes(lists).filter(function (list) {
      return list.closest('search-drawer, .search-drawer, predictive-search, .cs_custom_recommended_products_list');
    });
  }

  function getSearchTitles(scope) {
    let titles = Array.from((scope || document).querySelectorAll(SEARCH_TITLE_SELECTOR));

    if (scope && scope.shadowRoot) {
      titles = titles.concat(queryAllDeep(scope, SEARCH_TITLE_SELECTOR));
    }

    return uniqueNodes(titles);
  }

  function groupTitlesByRow(titles) {
    const rows = [];
    const tolerance = 16;

    titles.forEach(function (title) {
      const card = title.closest('product-card') || title;
      const top = card.getBoundingClientRect().top;
      let row = null;

      for (let i = 0; i < rows.length; i++) {
        if (Math.abs(rows[i].top - top) <= tolerance) {
          row = rows[i];
          break;
        }
      }

      if (!row) {
        row = { top: top, titles: [] };
        rows.push(row);
      }

      row.titles.push(title);
    });

    return rows;
  }

  function equalizeTitleGroup(titles) {
    const visibleTitles = titles.filter(isElementVisible);

    resetSearchbarTitleHeights(titles);

    if (!visibleTitles.length) return;

    visibleTitles[0].offsetHeight;

    const rows = groupTitlesByRow(visibleTitles);

    rows.forEach(function (row) {
      let maxHeight = 0;

      row.titles.forEach(function (title) {
        maxHeight = Math.max(maxHeight, title.scrollHeight, title.offsetHeight);
      });

      if (maxHeight <= 0) return;

      row.titles.forEach(function (title) {
        title.style.height = maxHeight + 'px';
        title.style.minHeight = maxHeight + 'px';
      });
    });
  }

  function equalSearchbarProductTitleHeight() {
    const lists = getSearchProductLists();
    const allSearchTitles = [];

    lists.forEach(function (list) {
      allSearchTitles.push.apply(allSearchTitles, getSearchTitles(list));
    });

    if (!allSearchTitles.length) return;

    if (!isSearchOpen()) {
      resetSearchbarTitleHeights(allSearchTitles);
      return;
    }

    lists.forEach(function (list) {
      if (!isElementVisible(list)) {
        resetSearchbarTitleHeights(getSearchTitles(list));
        return;
      }

      equalizeTitleGroup(getSearchTitles(list));
    });
  }

  function scheduleSearchbarTitleEqualize(delay) {
    window.setTimeout(function () {
      requestAnimationFrame(function () {
        equalSearchbarProductTitleHeight();
        observeSearchProductLists();
      });
    }, delay || 0);
  }

  function observeSearchProductLists() {
    if (typeof ResizeObserver === 'undefined') return;

    getSearchProductLists().forEach(function (list) {
      if (observedLists.has(list)) return;

      observedLists.add(list);

      let lastWidth = -1;
      const observer = new ResizeObserver(function (entries) {
        const width = Math.round(entries[0].contentRect.width);

        if (width === lastWidth) return;

        lastWidth = width;
        clearTimeout(listResizeTimer);
        listResizeTimer = setTimeout(equalSearchbarProductTitleHeight, 80);
      });

      observer.observe(list);
    });
  }

  scheduleSearchbarTitleEqualize(0);
  window.addEventListener('load', function () {
    scheduleSearchbarTitleEqualize(0);
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleSearchbarTitleEqualize(0);
    });
  }

  let resizeTimer;

  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);

    resizeTimer = setTimeout(function () {
      equalSearchbarProductTitleHeight();
    }, 200);
  });

  const searchDrawers = document.querySelectorAll('search-drawer, .search-drawer');

  searchDrawers.forEach(function (searchDrawer) {
    searchDrawer.addEventListener('dialog:after-show', function () {
      scheduleSearchbarTitleEqualize(50);
      scheduleSearchbarTitleEqualize(350);
    });

    const attrObserver = new MutationObserver(function () {
      scheduleSearchbarTitleEqualize(50);
      scheduleSearchbarTitleEqualize(350);
    });

    attrObserver.observe(searchDrawer, {
      attributes: true,
      attributeFilter: ['class', 'open']
    });

    const resultsObserver = new MutationObserver(function () {
      scheduleSearchbarTitleEqualize(30);
      scheduleSearchbarTitleEqualize(200);
      scheduleSearchbarTitleEqualize(450);
    });

    resultsObserver.observe(searchDrawer, {
      childList: true,
      subtree: true
    });

    const searchInput = searchDrawer.querySelector('input[type="search"], input[name="q"]');

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        scheduleSearchbarTitleEqualize(400);
      });
    }
  });

  document.querySelectorAll('predictive-search').forEach(function (predictiveSearch) {
    if (predictiveSearch.shadowRoot) {
      predictiveSearch.shadowRoot.addEventListener('slotchange', function () {
        scheduleSearchbarTitleEqualize(50);
        scheduleSearchbarTitleEqualize(300);
      });
    }
  });

  observeSearchProductLists();

}); 